import type { Language } from '../../../common/types/i18n.js'
import { LeaderboardHoverCardData } from '../../../common/utils/leaderboard-hover-card.js'
import { BadgeArt } from '../badge-art/badge-art.js'
import { UserBubble } from '../user-bubble/user-bubble.js'
import './leaderboard-hover-card.scss'

export interface LeaderboardHoverCardProps {
    name: string | null
    avatar: string | null
    data: LeaderboardHoverCardData
    lang: Language
}

export const LeaderboardHoverCard = ({ name, avatar, data, lang }: LeaderboardHoverCardProps) => (
    <div className="leaderboard-hover-card">
        <div className="leaderboard-hover-card__header">
            <UserBubble name={null} avatar={avatar} size="small" lang={lang} />
            <div className="leaderboard-hover-card__titles">
                <span className="leaderboard-hover-card__name">{name}</span>
                <span className="leaderboard-hover-card__stats">{data.statsLine}</span>
            </div>
        </div>
        <div className="leaderboard-hover-card__progress" aria-hidden="true">
            <div
                className="leaderboard-hover-card__progress-fill"
                style={{ width: `${data.progressPercent}%` }}
            />
        </div>
        {data.recentBadges.length > 0 && (
            <div className="leaderboard-hover-card__badges">
                {data.recentBadges.map((badge) => (
                    <BadgeArt
                        key={badge.id}
                        className="leaderboard-hover-card__badge-image"
                        art={badge.art}
                        state="active"
                        idPrefix={`hover${badge.id}`}
                        size={36}
                    />
                ))}
                {data.extraBadgesLabel && (
                    <span className="leaderboard-hover-card__badge-more">
                        {data.extraBadgesLabel}
                    </span>
                )}
            </div>
        )}
        {data.newestLine && <div className="leaderboard-hover-card__newest">{data.newestLine}</div>}
    </div>
)
